import React, { useState } from "react";
import img from '../../../assets/images/1.jpg'
import Icon from "../../Icon";

const AboutHome = () => {

    const [target, setTarget] = useState(1)

    return (
        <div className="abouts grid2 container reveal" id='abouts'>
            <div className="about-head">
                <div className="about-back-one reveal_2"></div>
                <div className="about-img reveal_1">
                    <div className="about-media">
                        <img src={img} alt="" className="reveal_3" />
                    </div>
                </div>
            </div>
            <div className="about-body reveal_4">
                <h2 className="about-title ">Commencez par la droite</h2>
                <div className="about-nav">
                    <ul className="navbar-about">
                        <li className={target == 1 ? "navbar-about-active navbar-about-list": "navbar-about-list trans-border1"} onClick={()=>setTarget(1)}><Icon name="edit"/> <span>Notre travail</span></li>
                        <li className={target == 2 ? "navbar-about-active navbar-about-list": "navbar-about-list trans-border1"} onClick={()=>setTarget(2)}><Icon name="livre"/> <span>Notre Vision</span></li>
                        <li className={target == 3 ? "navbar-about-active navbar-about-list": "navbar-about-list trans-border1"} onClick={()=>setTarget(3)}><Icon name="setting"/> <span>Notre objectif</span></li>
                    </ul>
                </div>
                 
                <div className="about-target">
                    <div className={target ==1 ? "toggle-about":"about-item"}>
                        <h2 className="about-title2">Le processus qui connaît le nôtre</h2>
                        <p className="toggle-para">Les membres de notre équipe amicale sont toujours prêts à vous aider à comprendre vos exigences technologiques actuelles et à vous fournir des suggestions sur vos besoins futurs.
                        </p>
                        <ol className="toggle-about-listing">
                            <li>Recueillir des renseignements près de chez vous</li>
                            <li>Des procédures efficaces pour un résultat positif</li>
                            <li>Réussir son lancement</li>
                            <li>Un produit fini</li>
                        </ol>
                    </div>
                    <div className={target ==2 ? "toggle-about":"about-item"}>
                        <h2 className="about-title2">Notre mission et notre vision</h2>
                        <p className="toggle-para">
                        Notre mission première est d'éduquer les gens sur les nouvelles technologies partout dans le monde. Et comment ces technologies peuvent nous aider dans nos vies.
                        </p>
                        <div className="toggle-about-flex-no">
                            <div className="toglle-svg">
                                <Icon name="quote"/>
                            </div>
                            <div>
                                <p className="toggle-para">Parfois, lorsque vous innovez, vous faites des erreurs. Il est préférable de les admettre rapidement et de continuer à améliorer votre innovation.</p>
                                <p className="toggle-about-user">Ib Sangaré ceo@sansoftic</p>
                            </div>
                        </div>
                    </div>
                    <div className={target ==3 ? "toggle-about":"about-item"}>
                        <p className="toggle-para">Nous disposons d'une base solide fondée sur les technologies existantes et émergentes, y compris d'excellents antécédents en matière de livraisons à temps. Nous sommes en train de devenir l'une des sociétés privées de recherche et de gestion de talents les plus prometteuses au monde. Le véritable défi auquel sont confrontées les entreprises dans le monde d'aujourd'hui est de rendre leurs produits et services attrayants pour tous.</p>
                        <div className="toggle-about-flex">
                            <div>
                                <Icon name="reaction"/>
                            </div>
                            <div>
                                <p className="toggle-para">"Transformez votre entreprise avec des résolutions adaptées à vos besoins et objectifs."</p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default AboutHome